import styled from "styled-components";

export const PaymentsContainer = styled.div`
  width: 100%;
`;
